import React from "react";
import { Link } from "react-router-dom";

import contactImage from '../assets/images/contact.svg'
import coffee from '../assets/images/shuttle.png'
import fiverr from '../assets/images/logos/fiverr.png'
import upwork from '../assets/images/logos/upwork.png'

export default function GetInTuch(){
    return(
        <>
         <div className="container relative md:mt-24 mt-16">
                <div className="grid md:grid-cols-1 grid-cols-1 items-center gap-[30px]">
                    

                    <div>
                        <div className="bg-white dark:bg-slate-900 rounded-xl shadow-md dark:shadow-gray-700 p-8">
                            <div className="d-block d-md-flex justify-between">
                                <div>
                                    <div className="d-flex">
                                        
                                        <h3 className="mb-6 text-3xl leading-normal font-medium">Let's <b className="text-orange-500">Start </b> a Project</h3>
                                    </div>                            
                                    <p className="text-lg">I’d love to collaborate on new projects. Let’s connect over coffee!</p>
                                </div>
                                <div className="align-self-end">
                                    <Link to="mailto:goharali1415@gmail.com"  className="py-2 px-5 inline-flex items-center font-medium tracking-wide border align-middle duration-500 text-[15px] text-center bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white rounded-xl mt-5">Contact me</Link>
                                </div>
                            </div>
                       
                            <div className="mt-16 text-center">
                                <p className="text-lg">or <b className="text-green-500">hire</b> me on</p>

                                <div className="d-flex justify-center mt-10 mb-2">
                                    <div>
                                    <Link to="https://www.fiverr.com//goharshah1415" target="new" className="w-32 h-14 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 flex justify-center items-center rounded-xl mx-auto py-4">
                                        <img src={fiverr} title='More' className="h-8" alt=""/> <spna className="ms-3">FIVERR</spna>
                                    </Link>
                                    </div>
                                    <div className="ms-4">
                                    <Link to="https://www.upwork.com/freelancers/~0173a0409945a37288" target="new" className="w-32 h-14 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 flex justify-center items-center rounded-xl mx-auto py-4">
                                        <img src={upwork} title='More' className="h-8" alt=""/> <spna className="ms-3">UPWORK</spna>
                                    </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}